var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2527 2.51378C7.90085 5.98128 3.54147 7.10565 3.54147 7.10565C3.2071 7.19128 2.86647 6.9894 2.78085 6.65503C2.69522 6.32065 2.8971 5.98003 3.23147 5.8944C3.23147 5.8944 7.38273 4.84253 9.4121 1.51065L8.18272 1.50003C7.83772 1.4969 7.56022 1.2144 7.56335 0.869401C7.56647 0.524401 7.84897 0.246901 8.19397 0.250026L10.869 0.273776C11.2102 0.276276 11.4858 0.551901 11.4883 0.893151L11.5115 3.50628C11.5146 3.85128 11.2371 4.13378 10.8921 4.1369C10.5471 4.14003 10.2646 3.86253 10.2615 3.51753L10.2527 2.51378ZM4.9396 17.75H2.13647C1.44585 17.75 0.886475 17.1907 0.886475 16.5V10.875C0.886475 10.1844 1.44585 9.62503 2.13647 9.62503H4.9396V17.75ZM6.1896 9.0219C6.1896 8.3194 6.75898 7.75003 7.46147 7.75003H9.2596C9.9621 7.75003 10.5315 8.3194 10.5315 9.0219V17.75H6.1896V9.0219ZM11.7815 6.5219C11.7815 5.8194 12.3508 5.25003 13.0527 5.25003H14.6365C15.3271 5.25003 15.8865 5.8094 15.8865 6.50003V16.5C15.8865 17.1907 15.3271 17.75 14.6365 17.75H11.7815V6.5219Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsfill);
export default __webpack_public_path__ + "static/media/reports.fill.301df0451c0ad0d3a99af551267fe9ab.svg";
export { ForwardRef as ReactComponent };